'use strict'

const promisify = require('promisify-es6')
const streamToValue = require('../utils/stream-to-value')

module.exports = (send) => {
  return promisify((args, opts, callback) => {
    if (typeof (opts) === 'function') {
      callback = opts
      opts = {}
    }

    send.andTransform({
      path: 'files/read',
      args: args,
      qs: opts
    }, streamToValue, callback)
  })
}



//////////////////
// WEBPACK FOOTER
// ./src/files/read.js
// module id = 517
// module chunks = 0